import type { UsageMetric } from "../../../types/admin";
import { createAdminBaseService } from "./adminBaseService";

const base = createAdminBaseService<UsageMetric, Record<string, unknown>>({
  tableName: "usage_metrics",
  searchColumns: [],
});

/** Read-only service for usage metrics — no create/update/delete. */
export class AdminUsageService {
  static getAll = base.getAll;
  static get = base.get;
}
